import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { YouthInfoCenterScheduleHour } from '@models/youth-info-center/youth-info-center';
import { SharedModule } from '@shared/shared.module';

export interface Schedule {
  label: string;
  hours: ScheduleHour[];
}

interface ScheduleHour {
  from: string;
  to: string;
}

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleComponent {
  @Input() schedules: Schedule[] = [];

  trackByScheduleName(_: number, schedule: Schedule): string {
    return schedule.label;
  }

  trackByHour(_: number, hour: YouthInfoCenterScheduleHour): string {
    return hour.from;
  }
}

@NgModule({
  imports: [SharedModule],
  declarations: [ScheduleComponent],
  exports: [ScheduleComponent],
})
export class ScheduleModule {}
